export enum DocumentType {
   USER = 'user',
   PROJECT = 'project',
   SCENE = 'scene',
   PLOT = 'plot',
   CHARACTER = 'character',
   LOCATION = 'location',
}
